import { getZonedDate } from '@eika-infrastruktur/date';

import { PaymentAction, PaymentActionType } from './actions';
import { paymentInitialState, PaymentState } from './state';

const reducer = (state: PaymentState, action: PaymentAction): PaymentState => {
    switch (action.type) {
        case PaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case PaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case PaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case PaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case PaymentActionType.OWNTEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case PaymentActionType.SET_KID:
            return {
                ...state,
                kid: action.payload,
            };
        case PaymentActionType.PAYMENT_DATE:
            return {
                ...state,
                paymentDate: action.payload,
            };
        case PaymentActionType.FIRST_BANKING_DATE_FROM_TODAY:
            return {
                ...state,
                firstBankingDateFromToday: action.payload,
            };
        case PaymentActionType.RESET:
            return {
                ...paymentInitialState,
            };
        case PaymentActionType.RESET_WITH_FROM_ACCOUNT:
            return {
                ...paymentInitialState,
                fromAccount: action.payload,
                paymentDate: getZonedDate(),
            };
        case PaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case PaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case PaymentActionType.SET_RECEIPT_TYPE:
            return {
                ...state,
                receiptType: action.payload,
            };
        case PaymentActionType.SET_IMMEDIATE:
            return {
                ...state,
                immediate: action.payload,
            };
        case PaymentActionType.ACCEPT_DUPLICATE:
            return {
                ...state,
                acceptDuplicate: action.payload,
            };

        case PaymentActionType.RESET_KID_AND_NOTE:
            return {
                ...state,
                kid: undefined,
                note: '',
            };
        case PaymentActionType.SET_INITIAL_KID_AND_NOTE:
            return {
                ...state,
                kid: action.payload.kid,
                note: action.payload.note ?? '',
                hasInitialKid: !!action.payload.kid?.value,
            };
        default:
            return state;
    }
};

const paymentReducer = (state: PaymentState, action: PaymentAction): PaymentState => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cPayment form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};

export default paymentReducer;
